<template>
    <v-container fluid>
        <v-card>
            <v-card-title>NEGOZI</v-card-title>
            <v-card-text>
                <v-row dense>
                    <v-col md="2">
                        <v-text-field
                            dense
                            label="Perc Casamadre"
                            v-model="perc_casamadre"
                            type="number"
                        ></v-text-field>
                    </v-col>
                    <v-col md="1" class="text-right">
                        <v-btn color="primary" small @click="savePercCasamadre"
                            >Salva<v-icon> mdi-content-save-cog </v-icon></v-btn
                        >
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col>
                        <v-data-table
                            :headers="headers"
                            :items="arrShops"
                            item-key="id"
                            class="elevation-1"
                        >
                            <template v-slot:item.actions="{ item }">
                                <v-icon
                                    small
                                    class="mr-2"
                                    @click="
                                        editShop = item;
                                        dialog = true;
                                    "
                                >
                                    mdi-pencil
                                </v-icon>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <DialogShopVue
            :open="dialog"
            @onClose="onCloseDialog"
            @onSave="onSaveDialog"
            :shop="editShop"
        ></DialogShopVue>
    </v-container>
</template>
<style lang="scss"></style>
<script>
import requests from "../../requests";
import DialogShopVue from "./DialogShop.vue";
export default {
    name: "shop-list-page",
    components: {
        DialogShopVue,
    },
    computed: {
        headers() {
            return [
                { text: "ID", value: "id" },
                { text: "Descrizione", value: "description" },
                { text: "Tipo", value: "type" },
                { text: "Magazzino", value: "us_magazzino" },
                { text: "MQ.", value: "metri_quadri" },
                { text: "Fatturato EBITDA", value: "fatturato_espositivo_lordo_ebitda" },
                { text: "Break Even", value: "break_even_point" },
                { text: "Azioni", value: "actions", divider: true },
            ];
        },
    },
    data: () => {
        return {
            dialog: false,
            editShop: {},
            arrShops: [],
            perc_casamadre: 0,
        };
    },
    mounted() {
        console.log("Shop List Mounted.");
        this.getShopList();
        requests.getPercCasamadre().then((res) => {
            this.perc_casamadre = res.data.perc_casamadre;
        });
    },
    methods: {
        onCloseDialog() {
            this.dialog = false;
        },
        onSaveDialog(data) {
            requests.saveShop(data).then(() => {
                this.getShopList();
                this.dialog = false;
            });
            console.log("save");
        },

        savePercCasamadre() {
            requests.savePercCasamadre(this.perc_casamadre);
        },

        getShopList() {
            requests.getShopList().then((res) => {
                this.arrShops = res.data;
                this.selectedShop = this.arrShops[0].id;
            });
        },
    },
};
</script>
